import gql from 'graphql-tag';

export const BidFields = gql`
  fragment BidFields on OdProtosHomeworkData_Bid {
    id
    bidPostingId
    branchId
    details {
      scopes {
        lineItemId
        description
        laborCost {
          totalCents
          totalMinutes
        }
        materialCost {
          unitCents
          unitLabel
          quantity
        }
      }
    }
    notes
    awardedBy {
      user {
        token
        fullName
      }
      actedAt
    }
    rejectedBy {
      user {
        token
        fullName
      }
      actedAt
    }
  }
`;
